<template>
	<div>
		子账号管理
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {}
		},
		methods: {},
		mounted() {}
	};
</script>
<style lang='scss' scoped>
</style>
